import AppHeader from "@/components/AppHeader";

export default {
  name: "master-car",
  components: {
    AppHeader
  },
  created() {
    this.getCompany();
    this.getCar();
  },
  data() {
    return {
      companies: "",
      cars: [],
      selectedCompany: localStorage.company_id,
      getCompaniesEnd: false,
      getCarsEnd: false
    };
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompaniesEnd = true;
    },
    async getCar() {
      this.getCarsEnd = false;
      let data = {
        company_id: this.selectedCompany
      };
      let res = await this.$store
        .dispatch("GET_CAR", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.cars = res.cars;
      this.getCarsEnd = true;
    },
    goCarEdit(carId) {
      this.$router.push({ path: `/master_car/${carId}/edit` });
    },
    deleteModal(carId) {
      this.deleteCarId = carId;
      this.$bvModal.show("modal-delete");
    },
    async deleteCar() {
      let res = await this.$store
        .dispatch("DELETE_CAR", {
          id: this.deleteCarId,
          data: {}
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (!res.error) {
        this.getCar();
      }
      this.$bvModal.hide("modal-delete");
    },
    isForwardShow(is_forward_hide) {
      let isShow = is_forward_hide == 0 ? "選択可能" : "選択できない";
      return isShow;
    }
  }
};
